import EpdCompilerVersionHistory from './EpdCompilerVersionHistory';
import { withVersionHistoryGuard } from 'pages/v2/WithVersionHistoryGuard';

export default withVersionHistoryGuard(EpdCompilerVersionHistory);
